import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { sidePanelYesNoAnswers } from 'app/modules/grant-review/constants/side-panel-answers.const';

@Component({
  selector: 'app-site-visit-financial',
  templateUrl: './site-visit-financial.component.html',
  styleUrls: ['./site-visit-financial.component.scss']
})
export class SiteVisitFinancialComponent implements OnInit {

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  @Input() siteVisitFinancialForm: FormGroup;
  @Input() isReadOnly: boolean;

  siteVisitFinancialAnswers = sidePanelYesNoAnswers;

  constructor() { }

  ngOnInit() {
  }

}
